import Vue from 'vue';
const state = {
    purchase: {
        supplier: {},
        distributor: {}
    },
    purchases: [],


}
const actions = {
    showPurchases: (context) => {
        return new Promise((resolve, reject) => {
            axios.get(`/api/purchases`).then(response => {
                context.commit('SHOW_PURCHASES', response.data)
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    showPurchase: (context, id) => {
        return new Promise((resolve, reject) => {
            axios.get(`/api/purchases/${id}`).then(response => {
                context.commit('SHOW_PURCHASE', response.data.data)
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    storePurchase: (context, payload) => {
        return new Promise((resolve, reject) => {
            axios.post(`/api/purchases`, payload).then(response => {
                context.commit('STORE_PURCHASE', response.data)
                Vue.$toast.success("Compra cadastrada");
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    updatePurchase: (context, payload) => {
        return new Promise((resolve, reject) => {
            axios.put(`/api/purchases/${payload.id}`, payload).then(response => {
                Vue.$toast.info("Compra atualizada");
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    destroyPurchase: (context, id) => {
        return new Promise((resolve, reject) => {
            axios.delete(`/api/purchases/${id}`).then(response => {
                Vue.$toast.error("Compra deletada");
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    }
}
const mutations = {

    SHOW_PURCHASE: (state, payload) => {
        state.purchase = payload
    },
    SHOW_PURCHASES: (state, payload) => {
        state.purchases = payload
    },
    STORE_PURCHASE: (state, payload) => {
        state.purchase = payload
    }
}
const getters = {
    purchase: state => {
        return state.purchase
    },
    purchases: state => {
        return state.purchases
    }
}
export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}